import { ZapVersions } from '@ctw/shared/context/zui-provider';
import { trimStart } from 'lodash-es';

// IMPORTANT! This logic to determine the correct navigation path is also found in zap/src/App.tsx
// If you are making updates you may need to update both places.
export const pathWithParameters = (url: string, parameters: Record<string, unknown>): string => {
  const newUrl = new URL(url, `${window.location.protocol}//${window.location.host}`);

  for (const [key, value] of Object.entries(parameters)) {
    if (value === null) {
      newUrl.searchParams.delete(key);
    } else {
      newUrl.searchParams.set(key, String(value));
    }
  }

  let newPathname = newUrl.pathname;

  const prefixesToRemove = [
    '/salesforce/v1',
    '/zap',
    ...ZapVersions.map((version) => `/${version}`),
  ];

  // Check if pathname starts with any of the prefixes and remove it
  for (const prefix of prefixesToRemove) {
    if (newPathname.startsWith(prefix)) {
      newPathname = newPathname.substring(prefix.length);
      break;
    }
  }

  return `${newPathname}${newUrl.search}${newUrl.hash}`;
};

interface HrefIsActiveOptions {
  href: string;
  pathname: string;
}

export const hrefIsActive = ({ href, pathname }: HrefIsActiveOptions): boolean => {
  const nonRelativeHref = href.replaceAll('.', '');
  const normalizedHref = trimStart(
    nonRelativeHref[0] === '/' ? nonRelativeHref.slice(1) : nonRelativeHref,
  );

  return pathname.includes(`${normalizedHref}`);
};
